webpackJsonp([31],{

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var Component = __webpack_require__(105)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_requestConfig__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storage__ = __webpack_require__(59);






/* axios.defaults.timeout = 10000
axios.defaults.baseURL = requestUrl.url
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded' */

var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_3__utils_requestConfig__["a" /* requestUrl */].url,
    timeout: __WEBPACK_IMPORTED_MODULE_3__utils_requestConfig__["a" /* requestUrl */].timeout
});

service.interceptors.request.use(
/**
 * 请求拦截器，在请求之前做配置
 */
function (config) {
    config.headers['Content-Type'] = 'application/json';
    // if (store.getters.token) {
    //     config.headers['Authorization'] = 'Bearer ' + getToken()
    // }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["a" /* getStore */])('token')) {
        config.headers['Authorization'] = 'Bearer ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["a" /* getStore */])('token');
    }
    return config;
}, function (error) {
    console.error(error);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(
/**
 * 响应拦截器，在请求之前做配置
 */
function (response) {
    var res = response.data;
    if (response.data.code === 504) {}

    if (response.data.status === 401) {
        // 跳到登录页面
        // Vue.prototype.$message.warning('请先登录')
        // router.go(-1)
        // removeStore('token')
    }
    return res;
}, function (error) {
    //console.log('err' + error.response)
    // 失败响应
    // if (err && err.response) {
    // switch (err.response.status) {
    //   case 400:
    //     err.message = '请求无效，请检查参数是否正确!'
    //     break

    //   case 401:
    //     err.message = '未经授权，访问被拒!'
    //     break

    //   case 403:
    //     err.message = '拒绝访问!'
    //     break

    //   case 404:
    //     err.message = `地址不存在!`
    //     break

    //   case 408:
    //     err.message = '请求超时!'
    //     break

    //   case 500:
    //     err.message = '系统错误!'
    //     break

    //   case 501:
    //     err.message = '该方法未实现!'
    //     break

    //   case 502:
    //     err.message = '网管出错!'
    //     break

    //   case 503:
    //     err.message = '服务不可用!'
    //     break

    //   case 504:
    //     err.message = '网关请求超时'
    //     break

    //   case 505:
    //     err.message = 'HTTP版本不受支持'
    //     break

    //   default:
    // }
    // if (err.response.data.error) {
    //   err.message = err.response.data.error
    // }
    // Vue.prototype.$message.closeAll()
    // Vue.prototype.$message.error(err.message)

    // 401无token
    if (error.response.data.status === 401) {
        /* store.dispatch('user/resetToken').then(() => {
          location.reload()
        }) */
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestUrl; });
var requestUrl = {
  // url: 'https://wxapi.yixiang.co/api',
  //url: 'http://localhost:11001/cbec/api/v1',
  url: 'https://shop.chengmeimedicine.com/cbec/api/v1',
  // url: 'http://122.9.152.120:39003/cbec/api/v1',
  // url: '/proxy',
  timeout: 30000
};

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store___ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_content_placeholders__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_login__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__);














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a.Loading.directive);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_9_element_ui___default.a.Loading.service;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_9_element_ui___default.a.Notification;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_9_element_ui___default.a.Message;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */], {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
var whiteList = ['/home', '/goods', '/moregoods', '/login', '/register', '/goodsDetails', '/thanks', '/search', '/refreshsearch', '/refreshgoods']; // 不需要登陆的页面
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  /* let params = {
    params: {
      token: getStore('token')
    }
  } */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_login__["a" /* getUserInfo */])().then(function (res) {
    if (res.status === 401) {
      // 无token
      if (whiteList.indexOf(to.path) !== -1) {
        // 白名单
        next();
      } else {
        next('/login');
      }
    } else {
      // 登录成功,记录用户信息
      __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */].commit('RECORD_USERINFO', { info: res.data });
      if (to.path === '/login') {
        //  跳转到
        next({ path: '/' });
      }
      next();
    }
  });
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_CART; });
var INIT_BUYCART = 'INIT_BUYCART';
var RESET_CART = 'RESET_CART';
var ADD_CART = 'ADD_CART';
var GET_USERINFO = 'GET_USERINFO';
var CLEAR_USERINFO = 'CLEAR_USERINFO';
var RECORD_USERINFO = 'RECORD_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__(59);



var _INIT_BUYCART$RESET_C;



/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$RESET_C = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = JSON.parse(initCart);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* RESET_CART */], function (state, newcartlist) {
  var cart = state.cartList; // 购物车
  newcartlist.forEach(function (newItem) {
    cart.forEach(function (item) {
      if (item.productId === newItem.productId) {
        newItem.checked = item.checked;
      }
    });
  });
  state.cartList = newcartlist;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_CART */], function (state, _ref) {
  var id = _ref.id,
      productId = _ref.productId,
      salePrice = _ref.salePrice,
      productName = _ref.productName,
      productImg = _ref.productImg,
      _ref$productNum = _ref.productNum,
      productNum = _ref$productNum === undefined ? 1 : _ref$productNum,
      secKillId = _ref.secKillId,
      uniqueId = _ref.uniqueId,
      sku = _ref.sku;

  var cart = state.cartList; // 购物车
  var falg = true;
  var goods = {
    id: id,
    productId: productId,
    salePrice: salePrice,
    productName: productName,
    productImg: productImg,
    secKillId: secKillId,
    uniqueId: uniqueId,
    sku: sku
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.productId === productId) {
        if (item.productNum >= 0) {
          falg = false;
          item.productNum += productNum;
        }
      }
    });
  }
  if (!cart.length || falg) {
    goods.productNum = productNum;
    goods.checked = '1';
    cart.push(goods);
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  // let timer = null
  state.showCart = showCart;
  // clearTimeout(timer)
  // if (showCart) {
  //   timer = setTimeout(() => {
  //     state.showCart = false
  //   }, 5000)
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* REDUCE_CART */], function (state, _ref4) {
  var productId = _ref4.productId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.productId === productId) {
      if (item.productNum > 1) {
        item.productNum--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* EDIT_CART */], function (state, _ref5) {
  var productId = _ref5.productId,
      productNum = _ref5.productNum,
      checked = _ref5.checked;

  var cart = state.cartList;
  if (productNum) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        item.productNum = productNum;
        item.checked = checked;
      }
    });
  } else if (productId) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        cart.splice(i, 1);
      }
    });
  } else {
    cart.forEach(function (item) {
      item.checked = checked;
    });
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* CLEAR_USERINFO */], function (state) {
  state.userInfo = {};
  state.login = false;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["c" /* removeStore */])('userInfo');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* RECORD_USERINFO */], function (state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('userInfo', info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$RESET_C, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* GET_USERINFO */], function (state, info) {
  if (state.userInfo && state.userInfo.username !== info.username) {
    return;
  }
  if (!state.login) {
    return;
  }
  if (!info.message) {
    state.userInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, info);
  } else {
    state.userInfo = null;
  }
}), _INIT_BUYCART$RESET_C);

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 59:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserInfo;
/* unused harmony export editUserInfo */
/* harmony export (immutable) */ __webpack_exports__["b"] = logoutWeb;
/* harmony export (immutable) */ __webpack_exports__["d"] = getVerify;
/* harmony export (immutable) */ __webpack_exports__["c"] = registerID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(106);


// H5登录授权
function login(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/login',
    method: 'post',
    data: data
  });
}

/**
 * 获取用户登录信息
 * @returns {*}
 */
function getUserInfo() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/userinfo',
    method: 'get'
  });
}

// 修改用户信息
/**
 avatar: this.formData.avatar,
 nickname: this.formData.nickname
 */
function editUserInfo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/user/edit',
    method: 'post',
    data: data
  });
}

// 退出登录
function logoutWeb() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/auth/logout',
    method: 'post'
  });
}

function getVerify(data) {
  // {
  //     "phone": "", 手机号码
  //     "type": "" 短信类型 bind绑定手机短信 login登陆短信 register注册短信
  // }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/register/verify',
    method: 'post',
    data: data
  });
}

// 创建账号
function registerID(data) {
  // {
  //     "account": "", 手机号码
  //     "captcha": "", 验证码
  //     "inviteCode": "", 邀请码
  //     "password": "", 密码
  //     "spread": "" 分销绑定关系的ID
  // }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])({
    url: '/register',
    method: 'post',
    data: data
  });
}

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(235);


var Index = function Index() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 270));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 247));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 248));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 246));
};
var GoodS = function GoodS() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 243));
};
var MoreGoodS = function MoreGoodS() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 245));
};
var goodsDetails = function goodsDetails() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 244));
};
var Cart = function Cart() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 241));
};
var order = function order() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 250));
};
var user = function user() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 269));
};
var orderList = function orderList() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 262));
};
var information = function information() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 261));
};
var addressList = function addressList() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 259));
};
var coupon = function coupon() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 260));
};
var support = function support() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 267));
};
var checkout = function checkout() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 242));
};
var payment = function payment() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 251));
};
var paysuccess = function paysuccess() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 252));
};
var Thanks = function Thanks() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 258));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 257));
};
var RefreshSearch = function RefreshSearch() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 256));
};
var RefreshGoods = function RefreshGoods() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 255));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 263));
};
var Alipay = function Alipay() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 249));
};
var Wechat = function Wechat() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 254));
};
var QQpay = function QQpay() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 253));
};
var submitAfterSales = function submitAfterSales() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 266));
};
var supportDetail = function supportDetail() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 268));
};
var prodEvaluate = function prodEvaluate() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 265));
};
var prodCollect = function prodCollect() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 264));
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{ path: 'home', component: Home }, { path: 'goods', component: GoodS }, { path: 'moregoods', name: 'moregoods', component: MoreGoodS }, { path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails }, { path: 'thanks', name: 'thanks', component: Thanks }, { path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods }]
  }, { path: '/login', name: 'login', component: Login }, { path: '/register', name: 'register', component: Register }, { path: '/cart', name: 'cart', component: Cart }, { path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch }, {
    path: '/order',
    name: 'order',
    component: order,
    children: [{ path: 'paysuccess', name: 'paysuccess', component: paysuccess }, { path: 'payment', name: 'payment', component: payment }, { path: '/search', name: 'search', component: Search }, { path: 'alipay', name: 'alipay', component: Alipay }, { path: 'wechat', name: 'wechat', component: Wechat }, { path: 'qqpay', name: 'qqpay', component: QQpay }]
  }, {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/orderList',
    children: [{ path: 'orderList', name: '订单列表', component: orderList }, { path: 'orderDetail', name: '订单详情', component: orderDetail }, { path: 'information', name: '账户资料', component: information }, { path: 'addressList', name: '收货地址', component: addressList }, { path: 'coupon', name: '我的优惠', component: coupon }, { path: 'support', name: '售后服务', component: support }, { path: 'submitAfterSales', name: '退款申请', component: submitAfterSales }, { path: 'supportDetail', name: '退款申请详情', component: supportDetail }, { path: 'prodEvaluate', name: '商品评价', component: prodEvaluate }, { path: 'prodCollect', name: '商品收藏', component: prodCollect }]
  }, { path: '/checkout', name: 'checkout', component: checkout }, { path: '*', redirect: '/home' }]
}));

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(164);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  login: false, // 是否登录
  userInfo: null, // 用户信息
  cartList: [], // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  receiveInCart: false, // 是否进入购物车
  showCart: false // 是否显示购物车
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  action: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[163]);


// WEBPACK FOOTER //
// static/js/app.fbd50c9d8ff6d2c75c77.js